import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { TraitementDto, ResultatTraitement } from "@lexi-clients/lexi";
import { TraitementsService } from "../../services/traitements.service";

@Component({
    selector: "app-traitement-status",
    templateUrl: "./traitement-status.component.html",
    styleUrls: ["./traitement-status.component.scss"],
    standalone: false
})
export class TraitementStatusComponent implements OnChanges {
  @Input() itemId: string;

  traitement: TraitementDto;
  loading: boolean = false;
  ResultatTraitement = ResultatTraitement;
  popupVisible = false;

  constructor(private readonly traitementService: TraitementsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemId?.currentValue) {
      this.loadTraitement();
    }
  }

  async loadTraitement(): Promise<void> {
    if (!this.itemId) return;

    this.loading = true;
    try {
      this.traitement = await this.traitementService.getLatestByItemId(
        this.itemId,
      );
    } finally {
      this.loading = false;
    }
  }

  getButtonClass(): string {
    if (
      !this.traitement ||
      this.traitement.resultat === ResultatTraitement.noResult
    ) {
      return "";
    }
    if (this.traitement.resultat === ResultatTraitement.succes) {
      return "btn-success";
    }
    if (
      this.traitement.resultat === ResultatTraitement.erreur ||
      this.traitement.resultat === ResultatTraitement.echec
    ) {
      return "btn-danger";
    }
    return "";
  }

  getButtonType(): string {
    if (
      !this.traitement ||
      this.traitement.resultat === ResultatTraitement.noResult
    ) {
      return "default";
    }
    if (this.traitement.resultat === ResultatTraitement.succes) {
      return "success";
    }
    if (
      this.traitement.resultat === ResultatTraitement.erreur ||
      this.traitement.resultat === ResultatTraitement.echec
    ) {
      return "danger";
    }
    return "default";
  }

  getButtonText(): string {
    if (
      !this.traitement ||
      this.traitement.resultat === ResultatTraitement.noResult
    ) {
      return "En cours (ou sans réponse)";
    }
    if (this.traitement.resultat === ResultatTraitement.succes) {
      return "Succès";
    }
    if (this.traitement.resultat === ResultatTraitement.annule) {
      return "Annulé";
    }
    if (
      this.traitement.resultat === ResultatTraitement.erreur ||
      this.traitement.resultat === ResultatTraitement.echec
    ) {
      try {
        const errorMessage = 'Erreur : ' + this.traitementService.readMetadataRaison(this.traitement);
        // Limiter la longueur du message à 25 caractères et ajouter "..." s'il est plus long
        return errorMessage.length > 25 
          ? `${errorMessage.substring(0, 25)}...` 
          : errorMessage;
      } catch {
        return "Erreur";
      }
    }
    return "En cours (ou sans réponse)";
  }

  getErrorMessage(): string {
    if (!this.traitement || 
        !(this.traitement.resultat === ResultatTraitement.erreur || 
          this.traitement.resultat === ResultatTraitement.echec)) {
      return '';
    }
    
    try {
      return this.traitementService.readMetadataRaison(this.traitement);
    } catch {
      return "Impossible d'extraire le message d'erreur";
    }
  }

  getResultatText(): string {
    if (!this.traitement) return "Aucun traitement trouvé";
    if (this.traitement.resultat === ResultatTraitement.succes) {
      return "Succès";
    } else if (this.traitement.resultat === ResultatTraitement.erreur) {
      return "Erreur";
    } else if (this.traitement.resultat === ResultatTraitement.echec) {
      return "Échec";
    } else if (this.traitement.resultat === ResultatTraitement.annule) {
      return "Annulé";
    } else {
      return "En cours (ou sans réponse)";
    }
  }

  openMetadataDialog(): void {
    this.popupVisible = true;
  }
}
